module.exports = __webpack_public_path__ + "img/bg8.93fec3bc.png";